export const METRIC_IDS = [
  "returnOnSpace",
  "coreRange",
  "shelfAlignment",
  "dosMos",
  "aesthetics",
  "expectedSales",
] as const;

export type MetricId = (typeof METRIC_IDS)[number];

export const METRIC_TRANSLATION_KEYS = {
  returnOnSpace: {
    description: "planogramMetrics.returnOnSpace.description",
    title: "planogramMetrics.returnOnSpace.title",
  },
  coreRange: {
    description: "planogramMetrics.coreRange.description",
    emptyReason: "planogramMetrics.coreRange.emptyReason",
    title: "planogramMetrics.coreRange.title",
  },
  shelfAlignment: {
    description: "planogramMetrics.shelfAlignment.description",
    title: "planogramMetrics.shelfAlignment.title",
  },
  dosMos: {
    description: "planogramMetrics.dosMos.description",
    title: "planogramMetrics.dosMos.title",
  },
  aesthetics: {
    description: "planogramMetrics.aesthetics.description",
    title: "planogramMetrics.aesthetics.title",
  },
  expectedSales: {
    description: "planogramMetrics.expectedSales.description",
    emptyReason: "planogramMetrics.expectedSales.emptyReason",
    title: "planogramMetrics.expectedSales.title",
  },
} as const;
